// src/components/TopInfoBar.jsx
import React from "react";
import { FiMapPin, FiMail, FiClock } from "react-icons/fi";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";

export default function TopInfoBar({ blue = "#3366CC" }) {
  const smallIcon = { width: 14, height: 14, flexShrink: 0 };
  const socialBtn = {
    width: 28,
    height: 28,
    borderRadius: 999,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
  };
  return (
    <div
      className="top-info-bar"
      style={{
        height: 40,
        background: blue,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        fontSize: 13,
        width: "100%",
      }}
    >
      <div className="content-wrapper" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", maxWidth: 1440, margin: "0 auto" }}>
      <div style={{ display: "flex", gap: 18, alignItems: "center" }}>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          <FiMapPin style={smallIcon} /> Bangkok, TH 10230
        </span>
        <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
          <FiMail style={smallIcon} /> info@smartclick.co.th
        </span>
      </div>
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            marginRight: 8,
          }}
        >
          <FiClock style={smallIcon} /> Office Hours: 9:30 AM - 6:30 PM
        </span>
        <a
          href="https://www.facebook.com/smartclickmedia"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          style={{ ...socialBtn, background: "#1877F2" }}
        >
          <FaFacebookF style={{ width: 14, height: 14 }} />
        </a>
        <a
          href="https://www.linkedin.com/company/smartclickmedia/?originalSubdomain=th"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
          style={{ ...socialBtn, background: "#0A66C2" }}
        >
          <FaLinkedinIn style={{ width: 14, height: 14 }} />
        </a>
      </div>
      </div>
    </div>
  );
}
